module.exports = __webpack_public_path__ + "static/media/dylanblue.df510dba.png";